'use client';
import * as Styled from './styled';
import useCommitHistory from '@/hooks/useCommitHistory';

import { IRepository } from '@/types';

import CommitDetails from '@/components/Commits/CommitDetails';
import CommitHistory from '@/components/Commits/CommitHistory';

import { Row, Card } from '@/ui/primatives';
import * as Icon from '@/ui/Icon';
import { colors } from '@/styles';

export const CommitIndicatorCard: React.FC<{
  repository: IRepository;
  branchName: string;
  resourcePath?: string;
}> = ({ repository, branchName, resourcePath }) => {
  return (
    <Card style={{ background: colors.secondary.lightGray1 }} stretch compressed>
      <CommitIndicator
        repository={repository}
        branchName={branchName}
        resourcePath={resourcePath}
        className="hide-mobile"
      />
    </Card>
  );
};

const CommitIndicator: React.FC<{
  repository: IRepository;
  branchName: string;
  resourcePath?: string;
  className: string;
}> = ({ repository, branchName, resourcePath, className }) => {
  const fullResourcePath = [branchName, resourcePath].join('/');
  const { commits, pagination } = useCommitHistory({
    repository,
    branchName,
    resourcePath: resourcePath || '/',
  });
  const commitCount = pagination?.total_entries;
  const commit = commits?.[0];

  return (
    <Styled.CommitIndicator>
      {commit ? (
        <>
          <CommitDetails commit={commit} />
          <CommitHistory
            commit={commit}
            repository={repository}
            fullResourcePath={fullResourcePath}
            commitCount={commitCount}
          />
        </>
      ) : (
        <Row alignItems="center" gap={5}>
          <Icon.Commit />
          <div>Last commit cannot be located</div>
        </Row>
      )}
    </Styled.CommitIndicator>
  );
};
